// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/receivables/proforma-invoices',
        component: () =>
            import('@/pages/[organisation]/receivables/proforma-invoices.vue'),
        name: 'accounts-receivable.proforma-invoices.search-proforma-invoices',
        meta: {
            loginRequired: true,
            permission: 'access.receivables.pro-forma-invoice.view-proforma-invoices',
        },

        children: [
            {
                path: 'create-proforma-invoice',
                component: () =>
                    import('@/pages/[organisation]/receivables/proforma-invoices/create-proforma-invoice.vue'),
                name: 'accounts-receivable.proforma-invoices.create-proforma-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.create-proforma-invoice',
                },
            },
            {
                path: ':id/duplicate',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.proforma-invoices" */ '@/pages/[organisation]/receivables/proforma-invoices/duplicate-proforma-invoice.vue'),
                name: 'accounts-receivable.proforma-invoices.duplicate-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.update-proforma-invoice',
                },
            },
            {
                path: ':id/update-proforma-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.proforma-invoices" */ '@/pages/[organisation]/receivables/proforma-invoices/proforma-invoice/[id]/edit.vue'),
                name: 'accounts-receivable.proforma-invoices.update-proforma-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.update-proforma-invoice',
                },
            },
            {
                path: ':id/convert-proforma-to-invoice',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.proforma-invoices" */ '@/pages/[organisation]/receivables/proforma-invoices/convert-proforma-to-invoice.vue'),
                name: 'accounts-receivable.proforma-invoices.convert-proforma-to-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.create-proforma-invoice',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.proforma-invoices" */ '@/pages/[organisation]/receivables/proforma-invoices/proforma-invoice/[id].vue'),
                name: 'accounts-receivable.proforma-invoices.view-proforma-invoice',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.view-proforma-invoices',
                },
                // children: [
                //     {
                //         path: 'email-proforma-invoice',
                //         component: () =>
                //             import(
                //                 /* webpackChunkName: "accounts-receivable.proforma-invoices" */
                //                 '@/app/accounts-receivable/proforma-invoices/views/EmailProformaInvoice.vue'
                //             ),
                //         name: 'accounts-receivable.proforma-invoices.email-proforma-invoice',
                //         meta: {
                //             loginRequired: true,
                //             permission: 'access.receivables.pro-forma-invoice.update-proforma-invoice',
                //         },
                //     },
                // ],
            },
            {
                path: ':id/history',
                component: () =>
                    import(/* webpackChunkName: "accounts-receivable.proforma-invoices" */ '@/pages/[organisation]/receivables/proforma-invoices/proforma-invoice-history.vue'),
                name: 'accounts-receivable.proforma-invoices.view-proforma-invoice-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.receivables.pro-forma-invoice.view-proforma-invoices',
                },
            },
        ],
    },
];
